import GenericButton from "@ui-components/Button/GenericButton"
import GenericDropdown from "@ui-components/Dropdown/GenericDropdown"
import React  from "react"
import { ReactComponent as AddServiceIcon } from "../../../../../assets/Icons/IconPlusNV.svg";
import { ReactComponent as DownloadQuoteIcon } from "../../../../../assets/Icons/Icon_FolderDown.svg";
import { useNavigate } from "react-router-dom";

export default function AddServiceTabs() {
    const serviceOptions = ["Add Port", "Add Connection", "Add DCI"];
    const navigate = useNavigate();

    const handleServiceSelect = (selected: string) => {
        switch (selected){
            case "Add Port":
            navigate("/kontrol/add-port");
            break;
            case "Add Connection":
            navigate("/kontrol/add-ipx");
            break;
            case "Add DCI":
            navigate("/kontrol/add-dc");
            break;
            default:
                console.warn("No rote selected");
        }
    }

    return (
        <div
            className="
                flex
                justify-end
                w-full
                mt-1
                px-5
            "
        >
            <div className="flex gap-4">
                <GenericDropdown
                    items={serviceOptions}
                    defaultLabel="Add Service"
                    onSelect={handleServiceSelect}
                    disabled={true}
                    icon={<AddServiceIcon className="h-6 w-6 text-semantic-text-secondary" />}
                    dropdownMaxWidthClass="w-[400px]"
                    buttonProps={{
                        label: "Add new service",
                        variant: "secondary",
                        shape:"ghost",
                        icon: <AddServiceIcon className="h-6 w-6" />,
                        iconPosition: "left",
                    }}
                />
                <GenericButton
                    variant="secondary"
                    size="md"
                    shape="ghost"
                    label="Download quote"
                    disabled={true}
                    icon={<DownloadQuoteIcon className="h-6 w-6 text-semantic-text-secondary" />}
                    // onClick={() => handleViewOrder(order)}
                />
            </div>
        </div>
    )
}
